import React from "react"
import { twMerge } from "tailwind-merge"

type Props = {
  disabled?: boolean
  onSubmit?: () => void
  onClick?: () => void
  className?: string
}

export const Button: React.FC<Props> = ({ children, disabled, onSubmit, onClick, className }) => {
  const onClickButton = onSubmit ?? onClick

  const buttonClass = disabled ? "btn-sub--disabled" : "btn-sub"
  return (
    <button className={twMerge(`${buttonClass} ${className}`)}
      disabled={disabled}
      onClick={() => {
        if (onClickButton) {
          onClickButton()
        }
      }}
    >
      <span>{children}</span>
    </button>
  )
}